/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as NotFoundRouteImport } from './routes/not-found'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedProfileRouteImport } from './routes/_authenticated/profile'
import { Route as AuthenticatedUsersIndexRouteImport } from './routes/_authenticated/users/index'
import { Route as AuthenticatedTablesIndexRouteImport } from './routes/_authenticated/tables/index'
import { Route as AuthenticatedStorageIndexRouteImport } from './routes/_authenticated/storage/index'
import { Route as AuthenticatedProductsIndexRouteImport } from './routes/_authenticated/products/index'
import { Route as AuthenticatedTablesResourceRouteImport } from './routes/_authenticated/tables/$resource'
import { Route as AuthenticatedProfileSettingsRouteImport } from './routes/_authenticated/profile/settings'
import { Route as AuthenticatedProfileSecurityRouteImport } from './routes/_authenticated/profile/security'
import { Route as AuthenticatedProfileGeneralRouteImport } from './routes/_authenticated/profile/general'
import { Route as AuthenticatedProfileAboutAppRouteImport } from './routes/_authenticated/profile/about-app'

const NotFoundRoute = NotFoundRouteImport.update({
  id: '/not-found',
  path: '/not-found',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedProfileRoute = AuthenticatedProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedUsersIndexRoute = AuthenticatedUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedTablesIndexRoute =
  AuthenticatedTablesIndexRouteImport.update({
    id: '/tables/',
    path: '/tables/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedStorageIndexRoute =
  AuthenticatedStorageIndexRouteImport.update({
    id: '/storage/',
    path: '/storage/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProductsIndexRoute =
  AuthenticatedProductsIndexRouteImport.update({
    id: '/products/',
    path: '/products/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTablesResourceRoute =
  AuthenticatedTablesResourceRouteImport.update({
    id: '/tables/$resource',
    path: '/tables/$resource',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProfileSettingsRoute =
  AuthenticatedProfileSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedProfileRoute,
  } as any)
const AuthenticatedProfileSecurityRoute =
  AuthenticatedProfileSecurityRouteImport.update({
    id: '/security',
    path: '/security',
    getParentRoute: () => AuthenticatedProfileRoute,
  } as any)
const AuthenticatedProfileGeneralRoute =
  AuthenticatedProfileGeneralRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () => AuthenticatedProfileRoute,
  } as any)
const AuthenticatedProfileAboutAppRoute =
  AuthenticatedProfileAboutAppRouteImport.update({
    id: '/about-app',
    path: '/about-app',
    getParentRoute: () => AuthenticatedProfileRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/login': typeof LoginRoute
  '/not-found': typeof NotFoundRoute
  '/profile': typeof AuthenticatedProfileRouteWithChildren
  '/profile/about-app': typeof AuthenticatedProfileAboutAppRoute
  '/profile/general': typeof AuthenticatedProfileGeneralRoute
  '/profile/security': typeof AuthenticatedProfileSecurityRoute
  '/profile/settings': typeof AuthenticatedProfileSettingsRoute
  '/tables/$resource': typeof AuthenticatedTablesResourceRoute
  '/products/': typeof AuthenticatedProductsIndexRoute
  '/storage/': typeof AuthenticatedStorageIndexRoute
  '/tables/': typeof AuthenticatedTablesIndexRoute
  '/users/': typeof AuthenticatedUsersIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/not-found': typeof NotFoundRoute
  '/profile': typeof AuthenticatedProfileRouteWithChildren
  '/': typeof AuthenticatedIndexRoute
  '/profile/about-app': typeof AuthenticatedProfileAboutAppRoute
  '/profile/general': typeof AuthenticatedProfileGeneralRoute
  '/profile/security': typeof AuthenticatedProfileSecurityRoute
  '/profile/settings': typeof AuthenticatedProfileSettingsRoute
  '/tables/$resource': typeof AuthenticatedTablesResourceRoute
  '/products': typeof AuthenticatedProductsIndexRoute
  '/storage': typeof AuthenticatedStorageIndexRoute
  '/tables': typeof AuthenticatedTablesIndexRoute
  '/users': typeof AuthenticatedUsersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/login': typeof LoginRoute
  '/not-found': typeof NotFoundRoute
  '/_authenticated/profile': typeof AuthenticatedProfileRouteWithChildren
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/profile/about-app': typeof AuthenticatedProfileAboutAppRoute
  '/_authenticated/profile/general': typeof AuthenticatedProfileGeneralRoute
  '/_authenticated/profile/security': typeof AuthenticatedProfileSecurityRoute
  '/_authenticated/profile/settings': typeof AuthenticatedProfileSettingsRoute
  '/_authenticated/tables/$resource': typeof AuthenticatedTablesResourceRoute
  '/_authenticated/products/': typeof AuthenticatedProductsIndexRoute
  '/_authenticated/storage/': typeof AuthenticatedStorageIndexRoute
  '/_authenticated/tables/': typeof AuthenticatedTablesIndexRoute
  '/_authenticated/users/': typeof AuthenticatedUsersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/not-found'
    | '/profile'
    | '/profile/about-app'
    | '/profile/general'
    | '/profile/security'
    | '/profile/settings'
    | '/tables/$resource'
    | '/products/'
    | '/storage/'
    | '/tables/'
    | '/users/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/not-found'
    | '/profile'
    | '/'
    | '/profile/about-app'
    | '/profile/general'
    | '/profile/security'
    | '/profile/settings'
    | '/tables/$resource'
    | '/products'
    | '/storage'
    | '/tables'
    | '/users'
  id:
    | '__root__'
    | '/_authenticated'
    | '/login'
    | '/not-found'
    | '/_authenticated/profile'
    | '/_authenticated/'
    | '/_authenticated/profile/about-app'
    | '/_authenticated/profile/general'
    | '/_authenticated/profile/security'
    | '/_authenticated/profile/settings'
    | '/_authenticated/tables/$resource'
    | '/_authenticated/products/'
    | '/_authenticated/storage/'
    | '/_authenticated/tables/'
    | '/_authenticated/users/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginRoute: typeof LoginRoute
  NotFoundRoute: typeof NotFoundRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/not-found': {
      id: '/not-found'
      path: '/not-found'
      fullPath: '/not-found'
      preLoaderRoute: typeof NotFoundRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/profile': {
      id: '/_authenticated/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AuthenticatedProfileRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/users/': {
      id: '/_authenticated/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof AuthenticatedUsersIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tables/': {
      id: '/_authenticated/tables/'
      path: '/tables'
      fullPath: '/tables/'
      preLoaderRoute: typeof AuthenticatedTablesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/storage/': {
      id: '/_authenticated/storage/'
      path: '/storage'
      fullPath: '/storage/'
      preLoaderRoute: typeof AuthenticatedStorageIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/products/': {
      id: '/_authenticated/products/'
      path: '/products'
      fullPath: '/products/'
      preLoaderRoute: typeof AuthenticatedProductsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tables/$resource': {
      id: '/_authenticated/tables/$resource'
      path: '/tables/$resource'
      fullPath: '/tables/$resource'
      preLoaderRoute: typeof AuthenticatedTablesResourceRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/profile/settings': {
      id: '/_authenticated/profile/settings'
      path: '/settings'
      fullPath: '/profile/settings'
      preLoaderRoute: typeof AuthenticatedProfileSettingsRouteImport
      parentRoute: typeof AuthenticatedProfileRoute
    }
    '/_authenticated/profile/security': {
      id: '/_authenticated/profile/security'
      path: '/security'
      fullPath: '/profile/security'
      preLoaderRoute: typeof AuthenticatedProfileSecurityRouteImport
      parentRoute: typeof AuthenticatedProfileRoute
    }
    '/_authenticated/profile/general': {
      id: '/_authenticated/profile/general'
      path: '/general'
      fullPath: '/profile/general'
      preLoaderRoute: typeof AuthenticatedProfileGeneralRouteImport
      parentRoute: typeof AuthenticatedProfileRoute
    }
    '/_authenticated/profile/about-app': {
      id: '/_authenticated/profile/about-app'
      path: '/about-app'
      fullPath: '/profile/about-app'
      preLoaderRoute: typeof AuthenticatedProfileAboutAppRouteImport
      parentRoute: typeof AuthenticatedProfileRoute
    }
  }
}

interface AuthenticatedProfileRouteChildren {
  AuthenticatedProfileAboutAppRoute: typeof AuthenticatedProfileAboutAppRoute
  AuthenticatedProfileGeneralRoute: typeof AuthenticatedProfileGeneralRoute
  AuthenticatedProfileSecurityRoute: typeof AuthenticatedProfileSecurityRoute
  AuthenticatedProfileSettingsRoute: typeof AuthenticatedProfileSettingsRoute
}

const AuthenticatedProfileRouteChildren: AuthenticatedProfileRouteChildren = {
  AuthenticatedProfileAboutAppRoute: AuthenticatedProfileAboutAppRoute,
  AuthenticatedProfileGeneralRoute: AuthenticatedProfileGeneralRoute,
  AuthenticatedProfileSecurityRoute: AuthenticatedProfileSecurityRoute,
  AuthenticatedProfileSettingsRoute: AuthenticatedProfileSettingsRoute,
}

const AuthenticatedProfileRouteWithChildren =
  AuthenticatedProfileRoute._addFileChildren(AuthenticatedProfileRouteChildren)

interface AuthenticatedRouteChildren {
  AuthenticatedProfileRoute: typeof AuthenticatedProfileRouteWithChildren
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedTablesResourceRoute: typeof AuthenticatedTablesResourceRoute
  AuthenticatedProductsIndexRoute: typeof AuthenticatedProductsIndexRoute
  AuthenticatedStorageIndexRoute: typeof AuthenticatedStorageIndexRoute
  AuthenticatedTablesIndexRoute: typeof AuthenticatedTablesIndexRoute
  AuthenticatedUsersIndexRoute: typeof AuthenticatedUsersIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedProfileRoute: AuthenticatedProfileRouteWithChildren,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedTablesResourceRoute: AuthenticatedTablesResourceRoute,
  AuthenticatedProductsIndexRoute: AuthenticatedProductsIndexRoute,
  AuthenticatedStorageIndexRoute: AuthenticatedStorageIndexRoute,
  AuthenticatedTablesIndexRoute: AuthenticatedTablesIndexRoute,
  AuthenticatedUsersIndexRoute: AuthenticatedUsersIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
  NotFoundRoute: NotFoundRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
